// extracted by mini-css-extract-plugin
export default {"unauthorizedRoot":"Unauthorized_unauthorizedRoot__kkLD5"};